import './../css/base.css';
import './../css/custom.css';
import './../css/publication.css';

import PublicationList from './PublicationList';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";

library.add(faUpRightFromSquare);

const version = process.env.REACT_APP_BUILD_VERSION || Date.now();

const Publications = () => {
  const { t } = useTranslation("publication");
  const [authors, setAuthors] = useState(null);
  const [preprints, setPreprints] = useState(null);
  const [confInt, setConfInt] = useState(null);
  const [journalInt, setJournalInt] = useState(null);
  const [confDom, setConfDom] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    document.title = "Publications | Yodai Suzuki / 鈴木 陽大";

    const loadJSON = async (path) => {
      const res = await fetch(`${process.env.PUBLIC_URL}/publication/${path}?v=${version}`, {
        cache: "no-store"
      });
      if (!res.ok) throw new Error(`${path}: ${res.status}`);
      return res.json();
    };

    Promise.all([
      loadJSON("authors.json"),
      loadJSON("preprints.json"),
      loadJSON("journal_int.json"),
      loadJSON("conf_int.json"),
      loadJSON("conf_dom.json"),
    ])
      .then(([authorsData, preprintsData, journalIntData, confIntData, confDomData]) => {
        setAuthors(authorsData);
        setPreprints(preprintsData);
        setConfInt(confIntData);
        setJournalInt(journalIntData);
        setConfDom(confDomData);
      })
      .catch((err) => {
        console.error("Failed to load publication data:", err);
        setError(true);
      });
  }, []);

  if (error) {
    return <div>Failed to load publications.</div>;
  }

  if (!authors || !preprints || !journalInt || !confInt || !confDom) {
    return <div></div>;
  }

  return (
    <div className="window-wrapper">
      <div className="content-wrapper">
        <h1 id="title">
          {t("h-publication")}
          {t("h-publication-sub") && (
            <span className="pub-h-sub"> / {t("h-publication-sub")}</span>
          )}
        </h1>

        <PublicationList heading={t("h-preprints")} data={preprints.list} authors={authors} />
        <PublicationList heading={t("h-journal-int")} heading_sub={t("h-journal-int-sub")} data={journalInt.list} authors={authors} />
        <PublicationList heading={t("h-conf-int")} heading_sub={t("h-conf-int-sub")} data={confInt.list} authors={authors} />
        <PublicationList heading={t("h-conf-dom")} heading_sub={t("h-conf-dom-sub")} data={confDom.list} authors={authors} />
      </div>

      <div className="spacer-mid posrel"></div>
    </div>
  );
};

export default Publications;
